import type { Ticket } from "../../types";
import { TicketPill } from "../../components/TicketPill/TicketPill";
import { TicketPillSkeleton } from "../../components/TicketPill/TicketPillSkeleton";
import "./SoldTickets.scss";
import { useEffect, useState } from "react";
import { getSoldTickets } from "../../useCases/tickets";
import type { Firestore } from "firebase/firestore";
import "./SoldTickets.scss";

interface SoldTicketsProps {
  db: Firestore;
  lottery: string;
}

export const SoldTickets = (props: SoldTicketsProps) => {
  const [soldTickets, setSoldTickets] = useState<Ticket[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getSoldTickets(props.db, props.lottery).then(setSoldTickets).finally(() => setLoading(false));
  }, []);

  const sortedTickets = soldTickets
    .slice() 
    .sort((a, b) => {
      const na = parseInt(a.identifier.replace(/[^0-9]/g, ""), 10);
      const nb = parseInt(b.identifier.replace(/[^0-9]/g, ""), 10);
      return na - nb;
    });

  return (
    <div className="sold-tickets">
      {loading
        ? 
          Array.from({ length: 100 }).map((_, i) => (
            <TicketPillSkeleton key={i} />
          ))
        : soldTickets.length === 0
        ? 
          <div className="no-data">
            <span>No hay boletos vendidos</span>
          </div>
        : 
          sortedTickets.map((ticket) => (
            <TicketPill key={ticket.identifier} ticket={ticket} />
          ))}
    </div>
  );
};
